import React, { useState } from "react";
import { Image } from "react-bootstrap";

import { LanguageConfig } from "config/CustomEnums";
import AdditionalQuestionPrompt from "./AdditionalQuestionPrompt";

import DeleteIcon from 'assets/images/deleteIcon.png';
import CustomerEdit from 'assets/images/customer_edit.svg';
import TitleError from 'assets/images/campaignStreamline/title_error.png';

import "./AdditionalQuestionBar.scss"

export const SingleConditionRow = ({
  isError,
  title,
  image,
  onEdit,
  onRemove,
  extraActionButton,
  customClassName="",
}) => {
  return <div className={`single-condition-row ${customClassName || ''}`}>
    {isError && <Image src={TitleError} className="single-preview-card-edit-title-error" />}

    <div className="text-bar-with-buttons ">
      <div className={`create-section-label`} >
        {image && <Image src={image} style={{ width: "48px", height: "48px", marginRight: "12px" }} />}
        {title}
      </div>
      <div>
        {extraActionButton}
        {onEdit && <button
          className="delete-condition-group-button"
          type="button"
          onClick={onEdit}
        >
          <Image src={CustomerEdit} className="content-delete-button" />
        </button>}
        {onRemove && <button
          className="delete-condition-group-button"
          type="button"
          onClick={onRemove}
        >
          <Image src={DeleteIcon} className="content-delete-button" />
        </button>}
      </div>
    </div>
  </div>
}

const AdditionalQuestionBar = ({
  data,
  onRemove = () => { },
  onEdit = () => { },
}) => {
  const title = data?.translations?.[LanguageConfig.english]?.fieldName
  const [showEditPrompt, setShowEditPrompt] = useState(false)
  return (<>
    <SingleConditionRow
      title={title}
      onEdit={() => {
        setShowEditPrompt(true)
      }}
      onRemove={onRemove}
    />
    <AdditionalQuestionPrompt
      defaultValue={data}
      show={showEditPrompt}
      setShow={setShowEditPrompt}
      onComfirm={onEdit}
    />
  </>)
}

export default AdditionalQuestionBar;